(function (angular) {
    'use strict';

    angular.module('app')
        .controller('sendMessageController', sendMessageController);

    sendMessageController.$inject = [
        'alerts',
        '$uibModalInstance',
        '$q',
        '$timeout',
        '$scope',
        'userId',
        'UsersApi',
        'ConnectsApi',
        'MessageThreadsApi'
    ];

    function sendMessageController(
        alerts,
        $uibModalInstance,
        $q,
        $timeout,
        $scope,
        userId,
        UsersApi,
        ConnectsApi,
        MessageThreadsApi
    ) {
        var vm = this;

        // properties
        vm.isLoading = false;
        vm.isLoadingMessage = '';
        vm.users = [];
        vm.selectedUser = [];
        vm.message = '';
        vm.previousSearch = '';
        vm.formErrors = {};

        // methods
        vm.close = $uibModalInstance.close;
        vm.filterUsers = filterUsers;
        vm.sendMessage = sendMessage;
        vm.filterTimeout = null;


        if (userId) {
            getReceipient();
        }

        /**
         * Gets the user we're sending this message to
         * @return {void}
         */
        function getReceipient() {
            vm.isLoadingMessage = 'Loading user...';
            vm.isLoading = true;

            UsersApi.get({
                id: userId
            }, function handleGetRecipientResponse(response) {
                // keep the data structure the same as when we're
                vm.selectedUser = [response.data];
                vm.isLoading = false;
            }, function handleGetRecipientError() {
                vm.isLoading = false;
            });
        }

        /**
         * Searches connected users by the provided string and assigns to scope
         * @param  {string} search - full name or email
         * @return {void}
         */
        function filterUsers(search) {
            if (!search || search === '' || search === vm.previousSearch) {
                return false;
            }
            vm.previousSearch = search;


            // Reset the timer (make sure we wait 300ms after the user stops typing)
            if (vm.filterTimeout) {
                $timeout.cancel(vm.filterTimeout);
            }

            vm.filterTimeout = $timeout(function () {
                // Clear current results
                vm.users = [];

                // Search for users
                ConnectsApi.get({ full_name: search }, function (response) {
                    angular.forEach(response.data, function (connect) {
                        vm.users.push(connect.user_to);
                    });
                });
            }, 300);

        }

        /**
         * Sends message to the user
         * @return {void}
         */
        function sendMessage() {
            vm.formErrors = {};

            if (!vm.selectedUser || vm.selectedUser.length === 0) {
                vm.formErrors.user = ['Choose a recipient'];
            }
            if (!vm.message || vm.message === '') {
                vm.formErrors.message = ['Message required'];
            }

            if (Object.keys(vm.formErrors).length) {
                return false;
            }

            vm.isLoading = true;

            if (vm.selectedUser.length === 1) {
                vm.selectedUser = vm.selectedUser[0];
            }

            MessageThreadsApi.save({
                user_id: vm.selectedUser.id,
                body: vm.message
            }, function handleThreadSuccess(response) {
                alerts.emit({
                    theme: 'success',
                    title: 'Message Sent'
                });
                $uibModalInstance.close(response);
            }, function handleThreadError() {
                vm.isLoading = false;
            });
        }

        // init
        // populate the receipient dropdown
        ConnectsApi.get(function (response) {
            angular.forEach(response.data, function (connect) {
                vm.users.push(connect.user_to);
            });
        });

        $scope.$on('modal.closing', function (event, reason, closed) {
            if (!closed && !vm.forceClose) {
                return event.preventDefault();
            }
        });
    }

}(angular));
